import { landingTrendingArticleListApi } from '@/entities/article';
import { NewLandingArticleItemProps } from '@/shared/types';
import { loggingError } from '@/shared/utils';

export const getTrendingContents = async () => {
  try {
    const response = await landingTrendingArticleListApi();

    const trendingContents: NewLandingArticleItemProps[] = response.data.map(
      (article) => {
        const articleNewsData = article.news_data;
        return {
          articleInfo: {
            id: articleNewsData.id,
            category: articleNewsData.category[0].name,
            categoryFlag: articleNewsData.category[0].flag,
            time: articleNewsData.read_time,
            title: articleNewsData.title,
            isPopular: articleNewsData.is_popular_news,
            isScrapped: articleNewsData.is_news_scrapped,
            imageUrl: articleNewsData.thumbnail_image,
          },
          countInfo: {
            changedCount: article.rank_diff,
            rank: article.rank,
          },
        };
      }
    );

    return trendingContents;
  } catch (error) {
    loggingError(error, {
      message: 'Failed to fetch TrendingContents data',
      path: '/',
      extra: {},
    });

    return [];
  }
};
